import {parseISO} from 'date-fns'
import {Table, Divider} from 'antd'

import styles from './ProfileConditions.module.scss'
import {useGetConditions} from 'common/api'
import {
  Text,
  Loader,
  Empty,
  CalendarDate,
  FolderBookmarkIcon,
  CheckCircleIcon,
} from 'common/components'
import {maybePluralize, formatDate} from 'common/helpers'

interface ContentProps {
  conditions: any[]
}

const columns = [
  {
    dataIndex: 'date',
    render: (date: string, record: any) => (
      <CalendarDate date={parseISO(date)} error={record.isOverdue} />
    ),
  },
  {
    dataIndex: 'description',
    render: (description: string, record: any) => (
      <Text color={record.isOverdue ? 'redError' : undefined}>
        {description}
      </Text>
    ),
  },
  {
    dataIndex: 'project',
    render: (project: any, {createdBy, createdAt}: any) => (
      <div>
        <div className={styles.realty}>
          <FolderBookmarkIcon className={styles.icon} width={16} />
          <span>{project?.title || ''}</span>
        </div>
        <p className={styles.created}>
          Created by {createdBy?.firstName || ''}
          <span className={styles.spacer} />
          {formatDate(createdAt)}
        </p>
      </div>
    ),
  },
]

const Content = ({conditions}: ContentProps) => {
  const today = new Date()
  const dataSource = conditions.map((condition) => ({
    ...condition,
    key: condition.uuid,
    isOverdue: today > parseISO(condition.date),
  }))
  const overdueCount = dataSource.filter(
    (condition) => condition.isOverdue
  ).length

  return (
    <>
      <Text as="h3" size="md" weight="bold" mb={18}>
        {maybePluralize(
          overdueCount || conditions.length,
          `${overdueCount ? 'overdue ' : ''}condition`
        )}
      </Text>
      <Divider className={styles.divider} />
      <Table
        className={styles.table}
        showHeader={false}
        pagination={false}
        columns={columns}
        dataSource={dataSource}
      />
    </>
  )
}

export default function ProfileConditions() {
  const {data: conditions} = useGetConditions()

  return (
    <div>
      {!conditions ? (
        <Loader />
      ) : !conditions.length ? (
        <Empty
          icon={<CheckCircleIcon width={40} height={40} />}
          title="conditions"
        />
      ) : (
        <Content conditions={conditions} />
      )}
    </div>
  )
}
